import { NavLink } from 'reactstrap';
import { ScrollLink } from 'react-scroll';

// Wrap NavLink in reactstrap with react-scroll ScrollLink
export default ScrollLink(NavLink);
